import React from 'react'
import { Route, Outlet } from 'react-router-dom'
import RouteGuard from 'components/AuthenticatedLayout/RouteGuard/RouteGuard'

import LoaderSitesMetrics from 'components/Cartography/LoaderMetrics'
import { Navigate } from 'router'

import TopologyLoading from './Body/Topology/LoadingSkeleton'
import Infras from './Body/Infras'
import Sites, { Card as Site } from './Body/Sites'
import SSIDsView from './Body/Ssids'

import Home, {
  HomeGoogleMap,
  HomeRedirect,
  HomeDevicesMap,
  HomeNoSurfaceArea,
  HomeForceFocus
} from './Body/Home/Home'

import Card from './Body/Infras/Card'
import MonitoringMapSkeleton from '../../components/global/CUK/Skeletons/MonitoringMapSkeleton'
import TopologyPage from './Body/Topology'
import ViewTracker from './ViewTracker'

const routes = () => [
  <Route
    path={'/monitoring'}
    element={(
      <RouteGuard requiredRoles={['supervision']}>
        <ViewTracker />
        <Outlet />
      </RouteGuard>
    )}
    key={'monitoring'}
  >
    <Route path={''} index element={<Navigate pathname={'map'} />} />,
    <Route
      path={'map/:focusId?'}
      element={(
        <LoaderSitesMetrics loader={<MonitoringMapSkeleton />}>
          {({ sites }) => (
            <HomeForceFocus>
              <Home  sites={sites} />
            </HomeForceFocus>
          )}
        </LoaderSitesMetrics>
      )}
    >
      <Route path={''} index element={<HomeGoogleMap />} />
      <Route path={'redirect_first_floor/:buildingId?'} element={<HomeRedirect />} />
      <Route path={'no_surface_areas'} element={<HomeNoSurfaceArea /> }/>
      <Route path={':buildingId/:floorId?/:deviceId?'} element={<HomeDevicesMap /> }/>
    </Route>
    ,
    <Route
      path={'sites'}
      element={<Sites />}
    >
      <Route path={':focusId'} element={<Site />} />
    </Route>
    ,
    <Route
      path={'ssids'}
      element={
        <SSIDsView />
      }
    />
    ,
    <Route
      path={'infras'}
      index
      element={<Navigate pathname={'hardwares/access_points'} />}
    />
    ,
    <Route
      path={'infras/hardwares'}
      element={<Navigate pathname={'access_points'} />}
    />
    ,
    <Route path={'infras/all'} element={<Navigate pathname={'access_points'} />} />,
    <Route
      path={'infras/hardwares/:hardwareType'}
      element={
        <Infras  />
      }
    >
      <Route path=":uuid" element={<Card />} />
    </Route>
    ,
    <Route
      path={'topology/:focusId?'}
      element={
        <RouteGuard requiredRoles={['topology']}>
          <LoaderSitesMetrics loader={<TopologyLoading />}>
            {({ sites }) => <TopologyPage sites={sites} />}
          </LoaderSitesMetrics>
        </RouteGuard>
      }
    />
  </Route>
]

export default routes
